import { render, staticRenderFns } from "./DepartmentSelect.vue?vue&type=template&id=aff65590&scoped=true&"
import script from "./DepartmentSelect.vue?vue&type=script&lang=js&"
export * from "./DepartmentSelect.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentSelect.vue?vue&type=style&index=0&id=aff65590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff65590",
  null
  
)

export default component.exports